module.exports = __webpack_public_path__ + "img/info.981bf3c7.svg";